import Pickr from "@simonwep/pickr";
import ImagePicker from 'src/javascripts/components/forms/ImagePicker';

export default class AccountsEdit {

  constructor() {}

  render() {

    // Change color preview on color input change
    const UpdateColorPrev = function(input) {
    	let color = input.val();
    	let prev = input.closest('.input-group').find('.input-group-append .input-group-text');
    	prev.css('background-color', color);
    }

    $('.color-group input').change(function() {
    	UpdateColorPrev($(this));
    });

    // Reset default colors on click
    $('.reset-default-colors').click(function() {
    	let color = $(this).attr('data-color');
    	let inverse = $(this).attr('data-inverse');
    	let g = $(this).closest('.color-group');
    	let cI = g.find('.color-input');
    	let iI = g.find('.inverse-input');
    	cI.val(color);
    	UpdateColorPrev(cI);
    	iI.val(inverse);
    	UpdateColorPrev(iI);
    });

    // Image picker
    if ($('.filepicker').length !== 0) {
      ImagePicker();

      // On show modal
      $('.show-images-modal').click(function () {
        let fieldGroupId = $(this).attr('data-field-group-id');
        $('#imagesModal').find('.select-image').attr('data-field-group-id', fieldGroupId);
      });

      // Apply selected image on click
      $('.select-image').click(function() {
        // Update hidden field
        let url = $('.uploaded-image-container.active').attr('data-image-url');
        let fieldGroupId = $(this).attr('data-field-group-id');
        $('#' + fieldGroupId).find('input[type=\'hidden\']').val(url);

        // Close modal
        $('#imagesModal').modal('hide');

        // Append image
        let src = $('.uploaded-image-container.active').find('img').attr('src');
        let image = "<img src=\'" + src + " \' class=\'img-fluid\'>";
        $('#' + fieldGroupId).find('.applied-image-container').empty().append(image);

      })

    }

    // Toggle Custom Report Disclosure field visibility based on checkbox
    const $includeCustomDisclosure = $('#includeCustomDisclosure');
    if ($includeCustomDisclosure.length === 0) {
      return;
    }

    // Remove any existing handler for this namespace to avoid duplicates on re-render
    $includeCustomDisclosure.off('change.accountsEdit');

    const toggleCustomReportDisclosureFields = function() {
      if ($(this).is(':checked')) {
        $('#customReportDisclosureFields').removeClass('d-none');
      } else {
        $('#customReportDisclosureFields').addClass('d-none');
      }
    };

    $includeCustomDisclosure.on('change.accountsEdit', toggleCustomReportDisclosureFields);
    toggleCustomReportDisclosureFields.call($includeCustomDisclosure[0]);

    // Color pickr
    if ( $('.primary-picker').length > 0 ) {
      const createPicker = function(el) {
        let def = $(el).attr('data-default');
        let cType = $(el).attr('data-type');
        let pickr = Pickr.create({
          el: el,
          theme: 'classic', // or 'monolith', or 'nano'
          default: def,
          useAsButton: true,
          components: {

            // Main components
            preview: true,
            opacity: false,
            hue: true,

            // Input / output Options
            interaction: {
              hex: true,
              rgba: true,
              cmyk: true,
              input: true,
              save: true
            }
          }
        });

        // On save
        pickr.on('save', (color, instance) => {
          let hex = color.toHEXA().toString();
          if (hex.length < 7) {
            let len = hex.length;
            let i = 1;
            while (len < 7) {
              hex = hex + hex.charAt(i);
              i += 1;
              len += 1;
            }
          }        
          let cClass = '.' + cType + '-color-input';
          $(cClass).val(hex);
          $(el).css('background-color', hex);
          instance.hide();
        });

        // Reset to default
        let reset = $('.reset-' + cType + '-colors');
        reset.click(function() {
          let color = $(this).attr('data-color');
          let g = $(this).closest('.color-group');
          let cI = g.find('input');
          cI.val(color);
          pickr.setColor(color, false);
        });

        // Update on direct input
        let colInput = $(el).closest('.input-group').find('.color-input');
        colInput.on('blur', function() {
          let col = $(this).val();
          $(el).closest('.input-group').find('.picker').css('background-color', col);
          pickr.setColor(col, false);
        });

      }

      // Create pickers
      createPicker('.primary-picker');
      createPicker('.primary-inverse-picker');
      createPicker('.secondary-picker');
      createPicker('.secondary-inverse-picker');

    }


  }

}